import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-controls',
  templateUrl: './turns-controls.component.html',
  styleUrls: ['./turns-controls.component.scss']
})
export class TurnsControlsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
